// --------------------------------------------------------------
// Created On: 2025-08-29
// Author: KC Willard
//
// Last Modified: 2025-08-29
// Modified By: KC Willard
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

//Determines if the current date (or a given date) is in PST or PDT.
//PST (UTC−8) is standard time, PDT (UTC−7) is daylight saving time.

// Helper: find the Nth occurrence of a weekday in a month
function nthWeekdayOfMonth(year: number, month: number, weekday: number, nth: number): Date {
  const firstOfMonth = new Date(Date.UTC(year, month, 1));
  const firstWeekday = firstOfMonth.getUTCDay();
  const offset = (7 + weekday - firstWeekday) % 7;
  const day = 1 + offset + (nth - 1) * 7;
  return new Date(Date.UTC(year, month, day));
}

export default function isPacificDaylightTime(dateStr: string): boolean {
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) {
    throw new Error("Invalid date string");
  }
  const year = date.getUTCFullYear();

  // DST starts: second Sunday in March, at 2:00 AM local time (i.e., 10:00 UTC)
  const dstStartLocal = nthWeekdayOfMonth(year, 2, 0, 2);
  dstStartLocal.setUTCHours(10, 0, 0, 0);

  // DST ends: first Sunday in November, at 2:00 AM local time (i.e., 9:00 UTC)
  const dstEndLocal = nthWeekdayOfMonth(year, 10, 0, 1);
  dstEndLocal.setUTCHours(9, 0, 0, 0);

  const nowUTC = date.getTime();

  // If current UTC time falls between DST start and end => PDT, otherwise PST
  if (nowUTC >= dstStartLocal.getTime() && nowUTC < dstEndLocal.getTime()) {
    return true;
  } else {
    return false;
  }
}
